import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { DropDownListModule, DropDownsModule } from "@progress/kendo-angular-dropdowns";
import { PopupModule } from "@progress/kendo-angular-popup";
import { SepidzGridModule } from "projects/sepidz-web-framework-data-grid/src/lib/grid.module";
import { ThemeModule } from "projects/sepidz-web-framework-shell/src/lib/@theme/theme.module";
import { SharedModule } from "projects/sepidz-web-framework-shell/src/lib/shared/shared.module";
import { TabularModule } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.module";
import { AccVoucherDetailFilterComponent } from "./acc-voucher-detail-filter/acc-voucher-detail-filter.component";
import { AccVoucherHeaderImportExcelFormComponent } from "./acc-voucher-header-import-excel/acc-voucher-header-import-excel-form.component";
import { AccVoucherDetailComponent } from "./accvoucher-detail/accvoucher-detail.component";
import { AccVoucherFormComponent } from "./accvoucher-form/accvoucher-form.component";
import { AccVoucherListComponent } from "./accvoucher-list/accvoucher-list.component";
import { AccvoucherModalListComponent } from "./accvoucher-modal-list/accvoucher-modal-list.component";

const components = [
  AccVoucherListComponent,
  AccVoucherFormComponent,
  AccVoucherDetailComponent,
  AccvoucherModalListComponent,
  AccVoucherDetailFilterComponent,
  AccVoucherHeaderImportExcelFormComponent,
];
@NgModule({
  declarations: [...components],
  exports: [...components],
  imports: [
    CommonModule,
    FormsModule,
    ThemeModule,
    TabularModule,
    SharedModule.forRoot(),
    SepidzGridModule,
    DropDownListModule,
    PopupModule,
    DropDownsModule,
  ],
})
export class AccVoucherModule {}
